var widget_default = {
  "card": "t2THL",
  "link": "Jt6LO",
  "container": "_5uTbc",
  "image": "skjOs",
  "right": "wSoY1",
  "cardLayout": "_9ZQpx",
  "content": "XJhJq",
  "title": "dyiEI",
  "subtitle": "KxPDX",
  "button": "EDwgW",
  "button_disabled": "KNthp",
  "buttonText": "OQof6",
  "slimLayout": "aB1gS",
  "contentText": "LUPze"
};
export {
  widget_default as default
};
//# sourceMappingURL=widget-scss.js.map
